import { Box, Card, CardContent, Typography, CardMedia } from "@mui/material";
import { sanitizeHTML } from "../../Utils/formattingUtils";
import { CustomCard } from "../CustomCard";
import MembershipFormButtons from "../MembershipFormButtons";

export const AboutUs = () => {
  const sections = [
    {
      title: 'Welcome to the Monmouth Ski Club',
      content: `
              <p>
                Monmouth Ski Club has been satisfying the appetite of skiers and riders for over 50 years. 
                In those 50 years, the club has created an environment suitable for all types of members: young and old, singles, couples and families. Although the club is based in Red Bank, NJ, 
                we have members who live in PA, CT, SC, and even VT.
                We range in ability from beginners to experts and we all enjoy each other's company both on and off the slopes.
              </p>
              <p>
                Our members work hard to maintain a comfortable family atmosphere at our lodge. 
                Whether it is the warm welcome upon arrival, the family style breakfasts and dinners, or just the way everyone says, "Hi"; we like to make everyone feel at home at our home away from home in the beautiful mountains of Vermont.
              </p>
          `,
      image: 'images/lift_image1.jpg',
    },
    {
      title: 'Home Away From Home',
      content: `
            <p>
              Our lodge is centrally located in Pittsford, Vemont, which is on the outskirts of Rutland. Staying at the lodge places our members within an hour of most of the major ski areas. Pico is 12.5 miles from home, while Killington is 20. It takes about 20 to 25 minutes to get to these resorts. Okemo is about 35 minutes away, and it takes about an hour to get to Sugarbush.
            </p>`,
      image: 'images/mountain.jpg',
    },
    {
      title: 'Discount Lift Tickets',
      content: `
            <p>
              As members of the New Jersey Ski Council, we are eligible to purchase substantially discounted vouchers for many ski areas. Vouchers are available at our meetings and at the lodge.
            </p>`,
      image: 'images/devils_fiddle.jpg',
    },
    {
      title: 'Bookings and Rooms',
      content: `
        <p>
          We have 3 private rooms for couples and 4 dorm rooms. Room assignments are generally first come first served, but other factors, such as length of stay, are also taken into consideration. 
        </p>
        <p>
          Bookings are done by emailing the <a href="documents/forms/Monmouth Ski Club Bookings Form 2024-2025.xlsx">booking form</a> to <a href="mailto:scherer118@gmail.com">scherer118@gmail.com</a>, then by sending a check for your stay by regular mail to the address on the bookings form.
        </p>`,
      image: 'images/lodge_basement.jpg',
    },
    {
      title: 'Breakfast and Dinner',
      content: `
        <p>
          Mark, our chef, really spoils us! Each weekend morning he comes to the lodge before the sun comes up so he can prepare us awesome breakfasts. 
        </p>
        <p>
          When we get home from skiing, there is a crock pot full of homemade soup waiting for us in the rec room. Then he brings us some delicious munchies that he's whipped us for us. Soon we hear the dinner bell, and go upstairs to a gourmet meal. 
        </p>
        <p>
          We always make room for his incredible homemade desserts. It's a good thing that we ski hard so that we can eat hearty!
        </p>`,
      image: 'images/lodge_meal.jpg',
    },
    {
      title: 'Lodge Procedures',
      content: `
      <p>
        <ul>
          <li>
            When you get to the lodge, use the side door by the driveway to drop off skis and boots. Skis go in the first room, and boots go in the rec room, on the heated floor near the stairs. All boot bags must go upstairs.
          </li>
            When you have unloaded, park your car in the parking lot.
          <li>
            There will be a list on the back door. Make sure that you highlight your name and check your room assignment.
          </li>
          <li>
            Towels and sheets are in the closets at the top of the stairs. All members and guests are responsible for changing their beds at the end of their stay.
          </li>
          <li>
            Everyone will also have a simple chore to keep the lodge clean. These jobs will be assigned by the lodge chairperson for that weekend. 
          </li>
          <li>
            There are no showers between the hours of 6 AM and 8 AM on weekends when we are all trying to get to the mountain.
          </li>
        </ul>
      </p>`,
      image: 'images/cheers.jpg',
    },
    {
      title: 'Brief Club History',
      content: `
        <p>
          <ul>
            <li>
              The origins of the club probably date back all the way to 1947! <a href='documents/Brief History.pdf'>Click here to learn more!</a>
            </li>
          </ul>
        </p>`,
      image: 'images/lodge_outside.jpg',
    }
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 2,
      }}
    >
      <Typography variant="h4" color="text.primary" gutterBottom>
        About Us
      </Typography>

      <CustomCard posts={sections} />
      <MembershipFormButtons/>
    </Box>
  )
};